import { useLocation } from 'react-router-dom';
import styled from 'styled-components';
import { RouteValue } from '../../../types';
import { LI, Link } from '..';
import { muiAllyTheme } from '../../../utils';
import { Destination } from '@ally/transmitigator';

interface IStyleProps {
  children?: React.ReactNode;
  subNav?: boolean;
  pushRight?: boolean;
}

interface IProps extends IStyleProps {
  to: RouteValue | string;
  transmitdestination?: Destination;
}

const StyledLI = styled(LI)<IStyleProps>`
  ${(props: IStyleProps): string => `
    margin-left: ${props.pushRight ? 'auto' : 0};
  `}
`;

const StyledNavLink = styled(Link)<IStyleProps>`
  font-weight: 400;
  ${(props: IStyleProps): string => `
    color: ${
      props.subNav ? muiAllyTheme.colors['blue-800'] : muiAllyTheme.colors.white
    };
    padding: ${props.subNav ? '0' : '0 15px'};
    font-size: ${props.subNav ? '0.9333rem' : '1.2rem'};
  `}
`;

type NavLinkProps = IProps & React.ComponentProps<typeof Link>;

const NavLink: React.FC<NavLinkProps> = (props) => {
  const { pathname } = useLocation();
  const { subNav, pushRight, className, ...linkProps } = props;

  return (
    <>
      {pathname !== props.to &&
        !(pathname === '/' && props.to === '/wealth-overview') && (
          <StyledLI subNav={subNav} pushRight={pushRight} className={className}>
            <StyledNavLink subNav={subNav} {...linkProps} />
          </StyledLI>
        )}
    </>
  );
};

export default NavLink;
